import { useCallback, useEffect, useState } from 'react';

/*
    🔥 ATAJO GLOBAL

    Registra Ctrl/Cmd + K en toda la app. Va UNA sola vez, al lado del
    router, igual que AppAlertHost.

    ⚠️ NO SE ABRE MIENTRAS ESCRIBÍS

    Si el foco está en un input, un textarea o un editor, el atajo se
    ignora: alguien escribiendo "k" con el ctrl todavía apretado no
    quiere abrir un buscador. Salvo que el paleta ya esté abierta, ahí
    el atajo la cierra.
*/

const IS_TYPING = () => {

    const EL = document.activeElement;

    if (!EL) return false;

    const TAG = EL.tagName;

    return TAG === 'INPUT' || TAG === 'TEXTAREA' || TAG === 'SELECT' || EL.isContentEditable;
};

export const useCommandPalette = ({ hotkey = 'k', isEnabled = true } = {}) => {

    const [useIsOpen, setIsOpen] = useState(false);

    const CB__open = useCallback(() => setIsOpen(true), []);
    const CB__close = useCallback(() => setIsOpen(false), []);
    const CB__toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    useEffect(() => {

        if (!isEnabled) return;

        const onKeyDown = (event) => {

            const IS_COMBO = (event.metaKey || event.ctrlKey)
                && event.key.toLowerCase() === hotkey.toLowerCase();

            if (!IS_COMBO) return;

            if (IS_TYPING() && !useIsOpen) return;

            event.preventDefault();
            setIsOpen((prev) => !prev);
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);

    }, [hotkey, isEnabled, useIsOpen]);

    return { isOpen: useIsOpen, open: CB__open, close: CB__close, toggle: CB__toggle };
};
